import React, { useEffect } from 'react';
import { Shield, Target, Users, CheckCircle, XCircle } from 'lucide-react';
import { CTABanner } from '../components/CTABanner';
export function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full" data-id="element-213" data-mp="29l6r9cr0jrii">
      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden" data-id="element-214" data-mp="2eigm57x68vdq">
        <div className="absolute inset-0 bg-cover bg-center z-0" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1200")'
      }} data-id="element-215" data-mp="2egdr29h5wc25"></div>
        <div className="absolute inset-0 bg-navy/80 z-10" data-id="element-216" data-mp="2s93bi9h1l8x5"></div>
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-217" data-mp="2x97vwal2mnsn">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-montserrat font-black text-white mb-6" data-id="element-218" data-mp="1guy4f7lj8ixl">
            About Softwash Pros
          </h1>
          <p className="text-xl text-cream max-w-3xl mx-auto" data-id="element-219" data-mp="1luu9la5yugeq">
            Dedicated to providing the safest, most effective exterior cleaning
            solutions.
          </p>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-16 md:py-24 bg-white" data-id="element-220" data-mp="1pl1q2j8wi3s1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221" data-mp="23jj7y0c4km21">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-222" data-mp="1yjn4c27cawn0">
            <div data-id="element-223" data-mp="1ylq59ha16a6i">
              <h2 className="text-3xl font-montserrat font-bold text-navy mb-6" data-id="element-224" data-mp="2dge6gj8eemgb">
                Our Story
              </h2>
              <p className="text-gray-600 text-lg mb-4" data-id="element-225" data-mp="28gi22ivsgt08">
                Founded locally, Softwash Pros was built on a simple premise:
                exterior cleaning shouldn't mean damaging your property. We saw
                too many homes damaged by high-pressure washing and knew there
                had to be a better way.
              </p>
              <p className="text-gray-600 text-lg mb-6" data-id="element-226" data-mp="2w4swb36zbufj">
                Today, we are the area's premier soft washing specialists. Our
                team of trained professionals uses state-of-the-art equipment
                and eco-friendly, biodegradable solutions to safely remove
                algae, mold, mildew, and dirt from your home's exterior.
              </p>
              <div className="flex items-center space-x-4 text-navy font-bold" data-id="element-227" data-mp="1xu0491tgl1dp">
                <div className="flex items-center" data-id="element-228" data-mp="22mt6nj1gfxmm">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-2" data-id="element-229" data-mp="27le8to09ordp" />
                  Fully Licensed
                </div>
                <div className="flex items-center" data-id="element-230" data-mp="2cjfodyyhi8kf">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-2" data-id="element-231" data-mp="2cm1xi310ww4r" />
                  Fully Insured
                </div>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-232" data-mp="2ljm3fp9tzglp">
              <img src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200" alt="Softwash Pros Team" className="w-full h-full object-cover" data-id="element-233" data-mp="m8b32qdmarhf" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission/Values */}
      <section className="py-16 bg-gray-50" data-id="element-234" data-mp="ewdboh159bey">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235" data-mp="euk14qneu71o">
          <div className="text-center mb-12" data-id="element-236" data-mp="9ybq9pg8x00b">
            <h2 className="text-3xl font-montserrat font-bold text-navy mb-4" data-id="element-237" data-mp="4yh05o4aoegb">
              Our Core Values
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto rounded-full" data-id="element-238" data-mp="12mr0lyofmu5b"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-239" data-mp="xmmmgfazybi9">
            <div className="bg-white p-8 rounded-xl shadow-soft text-center border border-gray-100" data-id="element-240" data-mp="xlbhic5texpk">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-241" data-mp="spw7xweubnyy">
                <Target className="w-8 h-8 text-navy" data-id="element-242" data-mp="3deahg56g9tyf" />
              </div>
              <h3 className="text-xl font-montserrat font-bold text-navy mb-3" data-id="element-243" data-mp="3dc61upz6v6ib">
                Quality
              </h3>
              <p className="text-gray-600" data-id="element-244" data-mp="113z8jaxyk4gk">
                We never cut corners. We use the best equipment and solutions to
                deliver exceptional results every time.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-soft text-center border border-gray-100" data-id="element-245" data-mp="r6bbufgskmvr">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-246" data-mp="w4cvb1i4qo7r">
                <Shield className="w-8 h-8 text-navy" data-id="element-247" data-mp="1ju7334nldml5" />
              </div>
              <h3 className="text-xl font-montserrat font-bold text-navy mb-3" data-id="element-248" data-mp="1otbcnwefhmc0">
                Integrity
              </h3>
              <p className="text-gray-600" data-id="element-249" data-mp="1asqun2gc7ujk">
                Honest pricing, transparent communication, and we stand behind
                our work with a satisfaction guarantee.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-soft text-center border border-gray-100" data-id="element-250" data-mp="3vj868tmdjk44">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-251" data-mp="3h0aavrmaogk">
                <Users className="w-8 h-8 text-navy" data-id="element-252" data-mp="3s09045a9zxq8" />
              </div>
              <h3 className="text-xl font-montserrat font-bold text-navy mb-3" data-id="element-253" data-mp="3n1z63y0af367">
                Customer First
              </h3>
              <p className="text-gray-600" data-id="element-254" data-mp="5u3zoetijtt4">
                Your property is treated with the utmost respect, as if it were
                our own home.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why We're Different */}
      <section className="py-16 md:py-24 bg-white" data-id="element-255" data-mp="34dkcr42hzd28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256" data-mp="34aoj3rxonajl">
          <div className="text-center mb-16" data-id="element-257" data-mp="3j2ymwedwdyio">
            <h2 className="text-3xl font-montserrat font-bold text-navy mb-4" data-id="element-258" data-mp="3eayv597zebx6">
              Soft Washing vs. Pressure Washing
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-259" data-mp="2qjtckmanp5j6">
              Understanding the difference is crucial for protecting your
              property's exterior.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-260" data-mp="3b9nldhxsqriy">
            {/* Soft Wash */}
            <div className="bg-navy rounded-2xl p-8 text-white shadow-xl relative overflow-hidden" data-id="element-261" data-mp="3f9xsixxbrnze">
              <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 bg-light-blue opacity-20 rounded-full blur-2xl" data-id="element-262" data-mp="3k38x0senzso5"></div>
              <h3 className="text-2xl font-montserrat font-bold mb-6 flex items-center" data-id="element-263" data-mp="2sbkq4lennycp">
                <CheckCircle className="w-8 h-8 text-light-blue mr-3" data-id="element-264" data-mp="2wcwiuzstszp4" />
                Soft Washing (Our Method)
              </h3>
              <ul className="space-y-4" data-id="element-265" data-mp="31bpwqtc0yspt">
                <li className="flex items-start" data-id="element-266" data-mp="31aoadspk6jss">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-267" data-mp="36bltc7ie7hvc" />
                  <span data-id="element-268" data-mp="gm9zpgm7q7rq">Uses low pressure (similar to a garden hose)</span>
                </li>
                <li className="flex items-start" data-id="element-269" data-mp="lklabtkc0mb0">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-270" data-mp="lja9a1i9tsnl" />
                  <span data-id="element-271" data-mp="261ks1szutgor">
                    Relies on specialized, eco-friendly cleaning solutions
                  </span>
                </li>
                <li className="flex items-start" data-id="element-272" data-mp="1wd2r9brkr9l4">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-273" data-mp="1wbrnvd21k3uj" />
                  <span data-id="element-274" data-mp="1rcy7ncvddyqo">Kills algae, mold, and bacteria at the root</span>
                </li>
                <li className="flex items-start" data-id="element-275" data-mp="1ndfp2nr0tzr0">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-276" data-mp="1na1onl1x40m7" />
                  <span data-id="element-277" data-mp="1ife8qakzcej8">Results last 4-6 times longer</span>
                </li>
                <li className="flex items-start" data-id="element-278" data-mp="1deqg5kh3rpmw">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-279" data-mp="18fdngj3jvoce" />
                  <span data-id="element-280" data-mp="37rzjsvmywgx8">
                    100% safe for siding, roofs, and delicate surfaces
                  </span>
                </li>
              </ul>
            </div>

            {/* Pressure Wash */}
            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 shadow-soft" data-id="element-281" data-mp="2bnakfocg98om">
              <h3 className="text-2xl font-montserrat font-bold text-gray-800 mb-6 flex items-center" data-id="element-282" data-mp="2gmm352wdmo8u">
                <XCircle className="w-8 h-8 text-red-500 mr-3" data-id="element-283" data-mp="22w0j3av6s89d" />
                Traditional Pressure Washing
              </h3>
              <ul className="space-y-4 text-gray-600" data-id="element-284" data-mp="26vrgvyj4rone">
                <li className="flex items-start" data-id="element-285" data-mp="1sxb01erk0hrj">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-286" data-mp="1swjb2msgpia8" />
                  <span data-id="element-287" data-mp="1xxfg53ojvah8">Uses destructive high pressure (up to 4000 PSI)</span>
                </li>
                <li className="flex items-start" data-id="element-288" data-mp="1jxo95mwgaucq">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-289" data-mp="1jyzdbntt644d" />
                  <span data-id="element-290" data-mp="1nyht656rvp0c">Only blasts away the surface layer of dirt</span>
                </li>
                <li className="flex items-start" data-id="element-291" data-mp="3ebfdq7zxao1b">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-292" data-mp="3icr62la6lnd7" />
                  <span data-id="element-293" data-mp="16ovvc8nbzczv">Leaves root spores behind to regrow quickly</span>
                </li>
                <li className="flex items-start" data-id="element-294" data-mp="12nal6v26lctd">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-295" data-mp="12ollgkwf42fq" />
                  <span data-id="element-296" data-mp="1geyyh1o627bx">Can force water behind siding causing mold</span>
                </li>
                <li className="flex items-start" data-id="element-297" data-mp="1bnqjzr7zbvrw">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-298" data-mp="1blw0mhccwbpx" />
                  <span data-id="element-299" data-mp="1qbbptsw8o93i">
                    High risk of stripping paint and damaging shingles
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <CTABanner data-id="element-300" data-mp="1ueglpcltdcj6" />
    </div>;
}